import React from 'react'

const EditModal = () => {
    return (
        <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel"
            aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content text-dark">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="exampleModalLabel">Update User & Roll</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal"
                            aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="page-body">
                            <div className="row g-3">
                                <div className="col-sm-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row g-3">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label className="form-label text-muted">First
                                                            Name</label>
                                                        <input type="text" className="form-control"
                                                            placeholder="Add First Name" />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label className="form-label text-muted">Last
                                                            Name</label>
                                                        <input type="text" className="form-control"
                                                            placeholder="Add Last Name" />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label
                                                            className="form-label text-muted">Email</label>
                                                        <input type="email" className="form-control"
                                                            placeholder="Add Email" />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label
                                                            className="form-label text-muted">Password</label>
                                                        <input type="Password" className="form-control"
                                                            placeholder="Add Password" />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label
                                                            className="form-label text-muted">About</label>
                                                        <textarea className="form-control"
                                                            rows="9"></textarea>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <input type="file" className="form-control" />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="btn-group" role="group"
                                                        aria-label="Basic radio toggle button group">
                                                        <input type="radio" className="btn-check"
                                                            name="btnradio" id="btnradio1"
                                                            defaultChecked />
                                                        <label className="btn btn-outline-primary"
                                                            htmlFor="btnradio1">Active</label>

                                                        <input type="radio" className="btn-check"
                                                            name="btnradio" id="btnradio2" />
                                                        <label className="btn btn-outline-primary"
                                                            htmlFor="btnradio2">In Active</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary"
                            data-bs-dismiss="modal">Close</button>
                        <button type="button" className="btn btn-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EditModal